import module from 'contabilidad/polizas/module.js'
import template from './template.html'

export class ContabilidadPolizasDeudoresdiversosComponent {
  fechaInicio
  fechaFin
  idOperadora
  idsEmpresas
  filtro = ''
  data = null
  divisas = null
  nuevoData = null
  opciones = {
    fecha_inicio: new Date(),
    fecha_fin: new Date(),
    id_operadora: undefined,
    ids_empresas: [],
  }

  constructor ($q, $dialog, $location, ContabilidadPolizasDeudoresDiversos) {
    this.$q = $q
    this.$dialog = $dialog
    this.$location = $location
    this.ContabilidadPolizasDeudoresDiversos = ContabilidadPolizasDeudoresDiversos
  }

  $onChanges (changes) {
    if (changes.fechaInicio && this.fechaInicio) this.opciones.fecha_inicio = this.fechaInicio
    if (changes.fechaFin && this.fechaFin) this.opciones.fecha_fin = this.fechaFin
    if (changes.idOperadora && this.idOperadora) this.opciones.id_operadora = this.idOperadora
    if (changes.idsEmpresas && this.idsEmpresas) this.opciones.ids_empresas = this.idsEmpresas
    if (changes.fechaInicio || changes.fechaFin || changes.idOperadora || changes.idsEmpresas) {
      this.obtenerInformacion()
    }
  }

  obtenerInformacion () {
    const {fecha_inicio, fecha_fin, id_operadora, ids_empresas} = this.opciones

    if (fecha_inicio && fecha_fin && id_operadora && ids_empresas) {
      this.ContabilidadPolizasDeudoresDiversos.get(fecha_inicio, fecha_fin, id_operadora, ids_empresas)
        .then(({data, divisas}) => {
          this.data = data
          this.divisas = divisas
          this.nuevoData = this.ordenarArray(this.data)
        })
    } else {
      this.data = null
      this.divisas = null
      this.nuevoData = []
    }
  }

  exportar () {
    this.$dialog.show('contabilidad.polizas.exportar', {
      data: this.nuevoData,
      fecha_inicio: this.opciones.fecha_inicio,
      config: {
        fecha_inicio: this.opciones.fecha_inicio,
        fecha_fin: this.opciones.fecha_fin,
        archivo: `Deudores Diversos ${this.opciones.fecha_inicio.toYMD()}`,
        tipo_poliza: 'deudoresDiversos',
      },
    })
  }

  buscar () {
    this.obtenerInformacion()
    this.$location.search({
      fecha_inicio: this.opciones.fecha_inicio.toYMD(),
      fecha_fin: this.opciones.fecha_fin.toYMD(),
      id_operadora: this.opciones.id_operadora,
      ids_empresas: this.opciones.ids_empresas,
    })
  }

  actualizarEmpresas (data) {
    this.opciones.ids_empresas = data.ids_empresas
    this.opciones.id_operadora = data.idOperadora
  }

  ordenarArray (data) {
    if (!data || data.length === 0) return []

    let nuevoData = []
    let aux = []
    let totalCargo = 0
    let totalAbono = 0
    let totalComple = 0
    let totalBanco = 0
    let referencias = []
    let Descripcion
    let Banco_Numero_Cuenta
    let Cuenta_Contable
    let Cuenta_Contable_Complementaria
    let Banco
    let Tipo_Moneda
    let Banco_Referencia
    let Fecha_Movimiento
    let Captura_Fecha
    let Divisa

    data.forEach((item) => {
      if (referencias.indexOf(item.Banco_Referencia) === -1) {
        referencias.push(item.Banco_Referencia)
      }
    })

    referencias.forEach((item) => {
      data.forEach((ele) => {
        if (item === ele.Banco_Referencia) {
          aux.push(ele)
          Descripcion = ele.Descripcion
          Banco = ele.Banco
          Banco_Numero_Cuenta = ele.Banco_Numero_Cuenta
          Cuenta_Contable_Complementaria = ele.Cuenta_Contable_Complementaria
          Banco_Referencia = ele.Banco_Referencia
          Tipo_Moneda = ele.Tipo_Moneda
          Divisa = ele.Divisa
          Cuenta_Contable = ele.Cuenta_Contable
          Fecha_Movimiento = ele.Fecha_Movimiento
          Captura_Fecha = ele.Captura_Fecha
          totalBanco += ele.Importe
          totalCargo += ele.Tipo_Moneda === '1' ? ele.Importe : ele.ImpDiv
          totalAbono += (ele.Comple + ele.Importe)
          totalComple += ele.Comple
        }
      })

      nuevoData.push({
        Banco_Numero_Cuenta: Banco_Numero_Cuenta,
        Cuenta_Contable: Cuenta_Contable,
        Cuenta_Contable_Complementaria: Cuenta_Contable_Complementaria,
        Divisa: Divisa,
        Fecha_Movimiento: Fecha_Movimiento,
        Banco: Banco,
        Captura_Fecha: Captura_Fecha,
        Tipo_Moneda: Tipo_Moneda,
        TotalCargo: totalCargo,
        TotalAbono: totalAbono,
        TotalComple: totalComple,
        TotalBanco: totalBanco,
        Descripcion: Descripcion,
        Banco_Referencia: Banco_Referencia,
        cuentas: aux,
      })

      aux = []
      totalBanco = 0
      totalCargo = 0
      totalAbono = 0
      totalComple = 0
    })

    return nuevoData
  }
}

module.component('contabilidadPolizasDeudoresdiversos', {
  controller: ContabilidadPolizasDeudoresdiversosComponent,
  template,
  bindings: {
    fechaInicio: '<',
    fechaFin: '<',
    idOperadora: '<',
    idsEmpresas: '<',
  },
})




// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/deudoresdiversos/component.js